import {clientRolesSlug} from "../../user/user-roles-actions";
import {Utils} from "../../shared/utils/utils";
import {Website} from "../../websites/website/website";

interface IUserActivityPlaceholders {
  new_timezone?: string;
  new_email?: string;
  new_workspace_name?: string;
  paypal_email?: string;
  number?: number;
  type?: string;
  new_subscription_name?: string;
  subscription_name?: string;
  website_count?: number;
  site_url?: string;
  urls?: string;
  site_title?: string;
  domain_id?: number;
  domain_parent_id?: number;
  domain_name?: string;
  php_new_version?: string;
  wp_new_version?: string;
  backup_date?: string;
  file_name?: string;
  optimization_mode?: string;
  plugin_name?: string;
  plugin_new_version?: string;
  addon_name?: string;
  theme_name?: string;
  theme_new_version?: string;
  invited_email?: string;
  invited_emails?: string;
  email?: string;
  role?: string;
  new_role?: string;
  all_domains?: boolean;
  site_urls?: string;
  new_card?: number;
  old_card?: number;
}

export interface IUserActivity {
  userName: string;
  userEmail: string;
  type: string;
  action: string;
  date: number;
  websiteId: number;
  success: boolean;
  placeholders: IUserActivityPlaceholders;
}

export interface IDeletedUserActivity {
  email: string;
  id: string;
  firstName: string;
  workspaceId: number;
  createdAt: number;
}

export interface IDeletedDomainActivity {
  id: number;
  name: string;
  parentId: number | null;
  siblingId: number | null;
  type: string;
}

export class UserActivity implements IUserActivity {
  userName: string;
  userEmail: string;
  type: string;
  action: string;
  date: number;
  websiteId: number;
  websiteParentId: number;
  success: boolean;
  placeholders: IUserActivityPlaceholders;

  constructor(activity, websites: Website[] = null) {
    try {
      activity.created_at.toMillis();
    } catch (e) {
      console.log(activity);
    }
    this.userName = activity.name || null;
    this.userEmail = activity.email || null;
    this.type = setActionType(activity.category, activity.placeholders.site_url) || null;
    this.action = activity.action || null;
    this.date = activity.created_at && activity.created_at.seconds && activity.created_at.toMillis() || null;
    this.websiteId = activity.domain_id || null;
    this.websiteParentId = activity.domain_parent_id || null;
    this.success = activity.status === 'success';
    this.placeholders = placeholdersMap(activity.placeholders, websites);
  }
}

export class DeletedUserActivity implements IDeletedUserActivity {
  email: string;
  id: string;
  firstName: string;
  workspaceId: number;
  createdAt: number;

  constructor(activity) {
    this.email = activity.email || null;
    this.id = activity.id || null;
    this.firstName = activity.name || null;
    this.createdAt = activity.created_at * 1000 || null;
    this.workspaceId = activity.workspace_id;
  }
}


export class DeletedDomainActivity implements IDeletedDomainActivity {
  id: number;
  name: string;
  parentId: number | null;
  siblingId: number | null;
  type: string;

  constructor(activity) {
    this.id = activity.id || null;
    this.name = activity.name || null;
    this.parentId = activity.parentId || null;
    this.siblingId = activity.siblingId || null;
    this.type = activity.type || null;
  }
}

function setActionType(type: string, site_url: string = null): string {
  if (site_url) {
    return site_url.replace(/^https?:\/\//i, '');
  }
  else {
    return Utils.capitalizeAll(type.replace('_', ' '));
  }
}

/** map some properties to readable structure */
function placeholdersMap(placeholders: any = {}, websites: Website[]): IUserActivityPlaceholders {
  const mapped: IUserActivityPlaceholders = {...placeholders};
  if (placeholders.domain_id && websites) {
    mapped.site_url = websites.find(website => website.id === placeholders.domain_id)
      .site_url
      .replace(/^https?:\/\//i, '');
  }
  if (placeholders.site_url) {
    mapped.site_url = placeholders.site_url.replace(/^https?:\/\//i, '');
  }
  if (placeholders.invited_emails) {
    mapped.invited_emails = parseToString(placeholders.invited_emails);
  }
  if (placeholders.site_urls) {
    mapped.site_urls = parseToString(placeholders.site_urls);
  }
  if (placeholders.new_role) {
    mapped.new_role = clientRolesSlug[placeholders.new_role];
  }
  if (placeholders.new_card) {
    mapped.new_card = placeholders.new_card.number;
  }
  if (placeholders.old_card) {
    mapped.old_card = placeholders.old_card.number;
  }
  if (placeholders.backup_date) {

    const formattedBackupDate = String(placeholders.backup_date).replace(
      /(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z/,
      '$1-$2-$3T$4:$5:$6Z'
    );

    const date = new Date(formattedBackupDate);

    mapped.backup_date = Utils.formatDate(date, 'MMM d, y,  hh:mm a');
  }
  return mapped;
}

function parseToString(stringify: string[] | string): string {
  try {
    let array: string[];
    if (typeof stringify === 'string') {
      array = JSON.parse(stringify).map(i => i.replace(/^https?:\/\//i, ''));
    }
    else if (Array.isArray(stringify)) {
      array = stringify.map(i => i.replace(/^https?:\/\//i, ''));
    }
    return  array.join(', ');
  }
  catch {
    return '';
  }
}

// function get
